module.exports = __webpack_public_path__ + "3f675d6ba0d27c97d9f9d77ad35f4e70.png";